import { createSelector } from '@reduxjs/toolkit';

import { getActiveStation } from './getActiveStation';
import { getGroupedProductionComponentInstancesForActiveScheduleLineGroup } from './scheduleStationSelectors';

export const getCurrentGroupedProductionComponentInstance = createSelector(
  getActiveStation,
  getGroupedProductionComponentInstancesForActiveScheduleLineGroup,

  (activeStation, groupedProductionComponentInstances) => {
    if (
      activeStation === null ||
      !activeStation.followsSchedule ||
      activeStation.currentProductionComponentInstanceGuid === null
    )
      return null;

    const { currentProductionComponentInstanceGuid } = activeStation;
    if (currentProductionComponentInstanceGuid === null || groupedProductionComponentInstances === null) return null;
    const currentGroupedProductionComponentInstance = groupedProductionComponentInstances?.find((groupedInstances) =>
      groupedInstances.productionComponentInstanceGuids.includes(currentProductionComponentInstanceGuid),
    );

    return currentGroupedProductionComponentInstance ?? null;
  },
);
